export default __webpack_public_path__ + "static/media/uploaded_meal.5717e601.png";